import { render, staticRenderFns } from "./Marcom.vue?vue&type=template&id=88933f46"
import script from "./Marcom.vue?vue&type=script&lang=js"
export * from "./Marcom.vue?vue&type=script&lang=js"
import style0 from "./Marcom.vue?vue&type=style&index=0&id=88933f46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports